










import Vue from 'vue'

export default Vue.extend({
  name: 'SmallQualityCellRenderer',

  props: {
    quality: Number,
  },

  computed: {
    stars (): number {
      return 5
    }
  }

})
